import "./ChipBadge.css";

interface ChipBadgeProps {
	/** Chip label, e.g. "Triple Captain". A dash means no chip. */
	chip: string | null;
	/** Transfer cost as negative points, e.g. -4. */
	hit?: number;
	inverted?: boolean;
	right?: boolean;
}

export const ChipBadge = ({ chip, hit = 0, inverted, right }: ChipBadgeProps) => {
	const hasChip = chip != null && chip !== "-";
	if (!hasChip && hit === 0) {
		return null;
	}
	return (
		<div className={`chip-row${right ? " right" : ""}`}>
			{hasChip && <span className={`chip-badge${inverted ? " inverted" : ""}`}>{chip}</span>}
			{hit !== 0 && (
				<span className="chip-badge hit" title="Transfer cost">
					{hit}
				</span>
			)}
		</div>
	);
};
